import { Box, Paper, Typography } from '@mui/material';
import React from 'react';

const ServicesGridCards = ({ data }) => {
  const columns = window.innerWidth < 600 ? 2: 3;
  const lastRowCount = data.length % columns;
  const lastRowStart = data.length - lastRowCount;
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
        gap: "20px",
        justifyContent: "center",
        padding: "0 5%",
      }}
    >
      {data.map((item, index) => (
        <Paper
          key={index}
          elevation={3}
          sx={{
            borderRadius: "5%",
            textAlign: "center",
            padding: "3%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {item.src && (
            <img
              src={item.src}
              alt={item.alt || ""}
              style={{
                boxSizing: "border-box",
                width: item.width || "100%",
                height: "auto",
                paddingTop: item.paddingTop || "0",
              }}
              loading="lazy"
            />
          )}

          {item.text && (
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: "21px",
                textAlign: "center",
                color: "#000000",
                paddingTop: "5%",
              }}
              dangerouslySetInnerHTML={{ __html: item.text }}
            />
          )}

          {/* Render description only if it's provided */}
          {item.description && (
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontSize: { xs: "8px", md: "14px" },
                textAlign: "center",
                padding: "4% 6% 1% 6%",
                color: "#555555",
              }}
            >
              {item.description}
            </Typography>
          )}
        </Paper>
      ))}
    </Box>
  );
};

export default ServicesGridCards;
